import { SP } from "../../http/serviceportalApi";
import { Permission } from "../../types";
import { includesAny } from "../../utils";

// Users can view the document set if they have at least one of these permissions
const permissionsByDocumentSet: Record<SP.DocumentSetType, Permission[]> = {
  lohnauswertung: [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsBetriebStandardRead,
    Permission.DocumentsPrivateHaushalteRead,
    Permission.DocumentsAufstellungNettoloehneRead,
    Permission.DocumentsBuchungsbelegeRead,
    Permission.DocumentsEinbehalt15Read,
    Permission.DocumentsLaborfondMonatlichRead,
    Permission.DocumentsLaborfondTrimestralRead,
    Permission.DocumentsLohnstreifenRead,
    Permission.DocumentsF24Read,
    Permission.DocumentsSchulgeldLehrlingeRead,
    Permission.DocumentsUeberweisungslisteRead,
    Permission.DocumentsWirtschaftsberaterRead,
  ],
  "zahlungsbestaetigung-f24": [
    Permission.DocumentsBetriebStandardRead,
    Permission.DocumentsZahlungsbestaetigungF24Read,
  ],
  einheitslohnbuch: [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsEinheitslohnbuchRead,
    Permission.DocumentsNummInailRead,
  ],
  "formblatt-770": [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsBetriebStandardRead,
    Permission.Documents770SemplificatoRead,
    Permission.Documents770OrdinarioRead,
  ],
  "formblatt-cu": [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsBetriebStandardRead,
    Permission.DocumentsCUDRead,
  ],
  matrikelbuch: [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsBetriebStandardRead,
    Permission.DocumentsPrivateHaushalteRead,
    Permission.DocumentsMatrikelbuchRead,
  ],
  arbeitsvertraege: [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsBetriebStandardRead,
    Permission.DocumentsPrivateHaushalteRead,
    Permission.DocumentsArbeitsvertraegeRead,
    Permission.DocumentsErklSteuerfreibetraegeRead,
  ],
  "lohn-rundschreiben": [
    Permission.DocumentsBetriebStandardRead,
    Permission.DocumentsLohnRundschreibenRead,
  ],
  "steuer-rundschreiben": [Permission.DocumentsSteuerRundschreibenRead],
  "prov-lohnstreifen": [
    Permission.DocumentsBetriebStandardRead,
    Permission.DocumentsPrivateHaushalteRead,
    Permission.DocumentsProvisorischerLohnstreifenRead,
  ],
  "zusaetzliche-auswertungen": [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsWirtschaftsberaterRead,
  ],
  jahresdokumente: [
    Permission.DocumentsBetriebOnlineServiceRead,
    Permission.DocumentsWirtschaftsberaterRead,
  ],
  "antrag-um-familiengeld": [],
  jahresauswertungen: [
    Permission.DocumentsJahresauswertungRead,
    Permission.DocumentsRevisorenRead,
  ],
};

export const getAuthorizedLuidsByDocumentSet = (
  member: SP.Member,
  set: SP.DocumentSetType,
) => {
  const permissions = permissionsByDocumentSet[set];
  if (includesAny(member.permissions ?? [], permissions)) {
    return member.luid !== undefined ? [member.luid] : [];
  }
  return (
    member.companies?.reduce(
      (state: number[], value) =>
        value.luid !== undefined &&
        includesAny(value.permissions ?? [], permissions)
          ? [...state, value.luid]
          : state,
      [],
    ) ?? []
  );
};
